import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Button, Divider, Form, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { ICON_STEP_4 } from './IconStep';
import EditorPrivacy from '../../../../../components/Shared/forms/EditorPrivacy';
import ProgressBar from './ProgressBar';
import Sticky from 'react-sticky-el';

const Step4 = (props) => {
    const { t } = useTranslation('consent');

    const onPreviousStep = () => {
        props.previousStep();
    };
    const onNextStep = () => {
        props.nextStep();
    };
    return (
        <div className="bg-white p-4 rounded-lg">
            <Sticky
                boundaryElement=".block_"
                stickyClassName="bg-white p-4 shadow rounded-lg z-50"
            >
                <div className="flex justify-between items-center w-full">
                    <Button
                        size="large"
                        className="!border-purple !text-purple"
                        onClick={onPreviousStep}
                    >
                        <ArrowLeftOutlined /> {t('Previous Step')}
                    </Button>
                    <Button type="primary" size="large" onClick={onNextStep}>
                        {t('Next Step')} <ArrowRightOutlined />
                    </Button>
                </div>
            </Sticky>
            <Divider />
            <div className="flex space-x-2 items-center">
                {ICON_STEP_4}
                <div>
                    <div className="text-base font-medium text-[#65707A]">
                        {t('Step')} 4 / 5
                    </div>
                    <div className="text-xl font-semibold">{t('Step3')}</div>
                </div>
            </div>
            <ProgressBar percent={80} />
            <Form.Item
                name="isRequireOtp"
                label={t(
                    'Require data owners to verify their identity with OTP via email'
                )}
                valuePropName="checked"
            >
                <Switch />
            </Form.Item>
            <Form.Item
                name="certificationTh"
                label={
                    <span className="text-sm font-semibold">
                        {t('Certificate')} (TH)
                    </span>
                }
            >
                <EditorPrivacy placeholder={`${t('Certificate')} (TH)`} />
            </Form.Item>
            <Form.Item
                name="certificationEn"
                label={
                    <span className="text-sm font-semibold">
                        {t('Certificate')} (EN)
                    </span>
                }
            >
                <EditorPrivacy placeholder={`${t('Certificate')} (EN)`} />
            </Form.Item>
            <Divider />
            <Form.Item
                name="contactChannelTh"
                label={
                    <span className="text-sm font-semibold">
                        {t('ContactChannel')} (TH)
                    </span>
                }
            >
                <EditorPrivacy placeholder={`${t('ContactChannel')} (TH)`} />
            </Form.Item>
            <Form.Item
                name="contactChannelEn"
                label={
                    <span className="text-sm font-semibold">
                        {t('ContactChannel')} (EN)
                    </span>
                }
            >
                <EditorPrivacy placeholder={`${t('ContactChannel')} (EN)`} />
            </Form.Item>
            {/* </div> */}
        </div>
    );
};

export default Step4;
